// extracted by mini-css-extract-plugin
export default {"text":"PEEOvGk46xcZxdFUTWCz"};